<template>
  <div class="nav-content">
    <span>科技让生活更美好</span>
    <div @click="toExcelImport" class="nav-content-div">返回</div>
  </div>
</template>

<script>
import api from '@/api/api';

export default {
  name: 'detailnavbar',
  data() {
    return {
      mac: '',
      dialogVisible: false,
    };
  },
  methods: {
    logout() {
      api.logout();
      this.$router.push('/');
    },
    toMicroPython() {
      window.open('/micropython');
    },
    macQrcode() {
      this.dialogVisible = true;
    },
    toExcelImport() {
      this.$router.push({ path: 'layout' });
    },
  },
};
</script>

<style lang="less" scoped>
.nav-content {
  width: 100%;
  height: 70px;
  background-color: #188fff;
  border-bottom: 1px solid #fff;
  span {
    color: #fff;
    line-height: 70px;
  }
  span:first-child {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 2px;
    padding-left: 40px;
  }
  span:last-child {
    font-size: 12px;
  }
  .nav-content-div {
    height: 70px;
    line-height: 70px;
    width: 150px;
    text-align: center;
    float: right;
    color: #fff;
    font-size: 16px;
    cursor: pointer;
    border-left: 1px solid #fff;
    letter-spacing: 4px;
  }
  div:hover {
    color: red;
  }
  .mac-dialog {
    .el-input {
      width: 250px;
      margin-bottom: 30px;
    }
    .el-form-item__label {
      font-size: 20px;
    }
    .el-form-div {
      width: 150px;
      height: 150px;
      margin: 0 0 0 30%;
      border: 1px solid #dddddd;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detailnavbar.vue